/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import { Box, H1, makeStyles, PageTitle } from '@perk-ui/core'
import { Redirect } from 'react-router-dom'

import { useUser } from '../../features/auth/AuthContext'

interface HomeProps {}

const useStyles = makeStyles((theme) => ({
  dashboardTitle: {
    marginBottom: theme.spacing(3),
  },
}))

const Home: React.FC<HomeProps> = () => {
  const classes = useStyles()
  const currentUser = useUser()
  // const isGeneral = currentUser?.accessUser.type === 'AccessViewer'

  if (currentUser?.accessUser?.sponsorId) {
    return <Redirect to={'/my-access'} />
  }

  return (
    <Box p={3}>
      <PageTitle title="Home" />
      <H1 className={classes.dashboardTitle}>{'Access'}</H1>
    </Box>
  )
}

export default Home
